export default __webpack_public_path__ + "static/media/before-400.aa94ddab.png";